<template>
  <v-checkbox
    @click="storingVModelData"
    :label="finalLabelName"
    density="compact"
    v-model="checkbox2"
  >
    <template v-slot:label>
      <button @click.stop="handlerToggle">
        {{ finalLabelName }}
      </button>
      <!-- <v-tooltip activator="parent" location="bottom">
        (Click to change)
      </v-tooltip> -->
    </template>
  </v-checkbox>
</template>

<script>
import { ref, onMounted, watchEffect } from "vue";
import { useStore } from "vuex";

export default {
  props: ["boxName1", "boxName2"],
  // data() {
  //   return {
  //     vmodelData: "",
  //     finalLabelName: "",
  //     toggleFlag: false,
  //   };
  // },
  setup(props, { emit }) {
    const vmodelData = ref("");
    const finalLabelName = ref("");
    const toggleFlag = ref(false);
    const affinityBoxFlag = ref(false);
    const currentCheckName = ref("");
    const countAffinity = ref(null);
    const store = useStore();
    const checkbox2 = ref(false);

    onMounted(() => {
      toggleFlag.value == false
        ? (finalLabelName.value = props.boxName1)
        : (finalLabelName.value = props.boxName2);
    });
    watchEffect(() => {
      let lastSearch = store.getters["Media/getAdditionalSelectedDataGetters"];
      let keys = Object.keys(lastSearch);
      if (Object.keys(lastSearch).length > 0) {
        // console.log(lastSearch, " last");
        // console.log(keys, "dropkeys");
        if (lastSearch["affinityAssociation"]) {
          if (
            lastSearch["affinityAssociation"][0] == 1 &&
            props.boxName1 === "Affinity/Association"
          ) {
            checkbox2.value = true;
            store.dispatch("Rawdata/setAffinityBoxesAction", true);
          }
          if (
            lastSearch["affinityAssociation"][0] == 2 &&
            props.boxName1 === "Non-Affinity/Association"
          ) {
            checkbox2.value = true;
            store.dispatch("Rawdata/setAffinityBoxesAction", true);
          }
        }
        //worksite
        if (keys.includes("worksiteVoluntary")) {
          if (
            lastSearch["worksiteVoluntary"][0] === 2 &&
            props.boxName1 === "Worksite/Voluntary"
          ) {
            finalLabelName.value = props.boxName1;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
          if (
            lastSearch["worksiteVoluntary"][0] === 1 &&
            props.boxName2 === "Non-Worksite/Voluntary"
          ) {
            finalLabelName.value = props.boxName2;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        //credit
        if (keys.includes("creditUnion")) {
          if (
            lastSearch["creditUnion"][0] === 2 &&
            props.boxName1 === "Credit Union"
          ) {
            finalLabelName.value = props.boxName1;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
          if (
            lastSearch["creditUnion"][0] === 1 &&
            props.boxName2 === "Non-Credit Union"
          ) {
            finalLabelName.value = props.boxName2;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        //prescreen
        if (keys.includes("is_prescreen")) {
          if (
            lastSearch["is_prescreen"][0] === 2 &&
            props.boxName1 === "Pre-Screen/Opt-Out"
          ) {
            finalLabelName.value = props.boxName1;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
          if (
            lastSearch["is_prescreen"][0] === 1 &&
            props.boxName2 === "Non-Pre-Screen/Opt-Out"
          ) {
            finalLabelName.value = props.boxName2;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        //retail
        if (keys.includes("is_citi")) {
          if (
            lastSearch["is_citi"][0] === 2 &&
            props.boxName1 === "Retail Card Study"
          ) {
            finalLabelName.value = props.boxName1;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
          if (
            lastSearch["is_citi"][0] === 1 &&
            props.boxName2 === "Non-Retail Card Study"
          ) {
            finalLabelName.value = props.boxName2;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        //fee
        if (keys.includes("FeeProduct")) {
          if (
            lastSearch["FeeProduct"][0] === 2 &&
            props.boxName1 === "Fee Product"
          ) {
            finalLabelName.value = props.boxName1;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
          if (
            lastSearch["FeeProduct"][0] === 1 &&
            props.boxName2 === "Ancillary Service - No Fee"
          ) {
            finalLabelName.value = props.boxName2;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        //refinance
        if (keys.includes("refinance")) {
          if (
            lastSearch["refinance"][0] === 2 &&
            props.boxName1 === "Refinance"
          ) {
            finalLabelName.value = props.boxName1;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
          if (
            lastSearch["refinance"][0] === 1 &&
            props.boxName2 === "Non-Refinance"
          ) {
            finalLabelName.value = props.boxName2;
            checkbox2.value = true;
            const checkedPayloads = {
              value: finalLabelName.value,
              status: true,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
      }
    });
    function storingVModelData(e) {
      // console.log(e.srcElement.labels[0].innerText, "e111");
      let temp = e.srcElement.labels[0].innerText;
      checkbox2.value = e.target.checked;
      // console.log("temp", temp);
      // checkbox2.value = e.target.checked;
      currentCheckName.value = temp;
      // let affinityStatus = store.getters["Rawdata/getAffinityBoxesGetters"];
      if (temp === "Affinity/Association") {
        store.dispatch("Rawdata/setAffinityBoxesAction", e.target.checked);
        // affinityBoxFlag.value = true;
        // if (!affinityStatus && countAffinity.value === null) {
        //   countAffinity.value = 0;
        //   store.dispatch("Rawdata/setAffinityBoxesAction", !affinityStatus);
        // } else {
        //   countAffinity.value = null;
        // }
      } else if (temp === "Non-Affinity/Association") {
        affinityBoxFlag.value = false;
        store.dispatch("Rawdata/setAffinityBoxesAction", false);
      }
      // // console.log(store.getters["Rawdata/getAffinityBoxesGetters"], "gett");
      emit("sendingData", temp);
    }

    function handlerToggle() {
      // console.log("oggleFlag.value", finalLabelName.value, toggleFlag.value);
      // checkbox2.value = 0;
      toggleFlag.value = !toggleFlag.value;
      let affinityBoxesStatus =
        store.getters["Rawdata/getAffinityBoxesGetters"];
      // if (currentCheckName.value === "Non-Affinity/Association") {
      //   store.dispatch("Rawdata/setAffinityBoxesAction", false);
      // }
      if (toggleFlag.value === true) {
        store.dispatch("Rawdata/setAffinityBoxesAction", false);
      } else {
        if (affinityBoxesStatus) {
          store.dispatch("Rawdata/setAffinityBoxesAction", true);
        }
      }
      toggleFlag.value === false
        ? (finalLabelName.value = props.boxName1)
        : (finalLabelName.value = props.boxName2);
      const checkedPayloads = {
        value: finalLabelName.value,
        status: false,
      };
      console.log(checkedPayloads, " 22checkedPayloads");
      store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
      if (
        toggleFlag.value &&
        finalLabelName.value === "Non-Affinity/Association"
      ) {
        store.dispatch("Rawdata/setAffinityBoxesAction", false);
      }
    }

    return {
      checkbox2,
      vmodelData,
      finalLabelName,
      currentCheckName,
      toggleFlag,
      storingVModelData,
      handlerToggle,
      countAffinity,
    };
  },
};
</script>

<style scoped>
.checkbox-class {
  grid-area: auto !important;
  min-height: 0px !important;
  padding-top: 0px !important;
}

.v-input--density-default {
  --v-input-control-height: 0px;
}

.v-input__details {
  grid-area: auto !important;
}

.v-input__control {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.custom-checkbox .v-input--selection-controls:not(.v-input--radio) {
  grid-area: unset !important;
  min-height: 0px !important;
}
</style>
